import { createFileRoute } from "@tanstack/react-router";
import { DatePage } from "@/components/pages/DatePage";
import { todayISO, parseISO } from "@/lib/calendar/dates";
import { withSlash } from "@/lib/url";
import { MONTH_SLUGS_EN } from "@/i18n/paths";

const MONTH_NAMES_EN = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const Route = createFileRoute("/en/today")({
  loader: () => parseISO(todayISO())!,
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { y, m, d } = loaderData;
    const longDate = `${d} ${MONTH_NAMES_EN[m - 1]} ${y}`;
    const title = `Today ${longDate} - What Day, Weton & Hijri`;
    const desc = `Today ${longDate}: weekday, Javanese weton, Hijri, Balinese, holiday status.`;
    const canonicalEn = `https://hari.co.id${withSlash(`/en/calendar/${y}/${d}-${MONTH_SLUGS_EN[m - 1]}`)}`;
    const here = `https://hari.co.id/en/today/`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:locale", content: "en_US" },
        { property: "og:url", content: here },
      ],
      links: [{ rel: "canonical", href: canonicalEn }],
    };
  },
  component: EnTodayPage,
});

function EnTodayPage() {
  const { y, m, d } = Route.useLoaderData();
  return <DatePage y={y} m={m} d={d} locale="en" />;
}